import React, { useMemo, useEffect } from 'react'
import useSettings from 'hooks/redux/useSettings';
import { Dropdown } from '@missionlabs/smartagent-app-components';
import { SADropdownProps, SADropdownOption } from '@missionlabs/smartagent-app-components/dist/Dropdown';
import { userHierarchyToDropdown } from 'utils';
import { IHierarchyFilter } from 'store/metrics/metrics.state';
import { useDispatch } from 'react-redux'
import { getUserHierarchy } from 'store/settings/settings.actions';

interface Props extends Omit<SADropdownProps, "options" | "onChange"> {
    onSelect(hierarchy: IHierarchyFilter):void;
    onClear?:()=>void;
    selectedHierarchyID?:string;
    filterFn?:(hier:IHierarchyFilter)=>boolean;
    autoValue?:boolean;
}

const HierarchiesDropdown: React.FC<Props> = ({ selectedHierarchyID, filterFn, onSelect, value, autoValue ,onClear, ...props}) => {
    const { userHierarchy } = useSettings();
    const dispatch = useDispatch();

    const options = useMemo(() => {
        return userHierarchyToDropdown(userHierarchy) 
    }, [userHierarchy])

    useEffect(()=>{
        if(!userHierarchy){
            dispatch(getUserHierarchy())
        }
    },[userHierarchy, dispatch])

    const getAutoValue = ( ) => {
        if(!selectedHierarchyID) return;
        const parts = selectedHierarchyID.split('/');
        return parts.map((p,i)=>{
            switch(i){
                case 0:
                    return userHierarchy?.LevelOne.groups.find(g=>g.Id===p)?.Name
                case 1:
                    return userHierarchy?.LevelTwo?.groups.find(g=>g.Id===p)?.Name
                case 2:
                    return userHierarchy?.LevelThree?.groups.find(g=>g.Id===p)?.Name
                case 3:
                    return userHierarchy?.LevelFour?.groups.find(g=>g.Id===p)?.Name
                case 4:
                    return userHierarchy?.LevelFive?.groups.find(g=>g.Id===p)?.Name
                default:
                    return '';
            }
        }).join(' / ')
    }

    return (
        <Dropdown
            {...props}
            title={props.title ?? "Select agent hierarchy"}
            label={props.label ?? "Agent hierarchy"}
            value={autoValue ? getAutoValue() : value}
            filter
            options={options}
            onClear={onClear}
            onChange={(value: SADropdownOption<IHierarchyFilter>) => onSelect(value.data)}
        />
    )
}

export default HierarchiesDropdown
